export default __webpack_public_path__ + "static/media/ic-alarm-massage-unread.44f87b3e.svg";